package com.example.readingnotes.data.remote.dto

import kotlinx.serialization.Serializable

@Serializable
data class UserDto(
    val id: String, // UUID
    val username: String,
    val email: String? = null,
    val role: String,
    val totpEnabled: Boolean,
    val defaultTenantId: String? = null, // UUID
    val activeTenantId: String? = null, // UUID
)

@Serializable
data class RegisterRequestDto(
    val username: String,
    val password: String,
    val email: String? = null,
)

@Serializable
data class UsernameLoginRequestDto(
    val username: String,
    val password: String,
)

@Serializable
data class UsernameLoginResponseDto(
    val id: String, // UUID
    val username: String,
    val email: String? = null,
    val role: String,
    val totpEnabled: Boolean,
    val isAdmin: Boolean,
    val defaultTenantId: String? = null, // UUID
    val activeTenantId: String? = null, // UUID
)

@Serializable
data class TotpVerifyRequestDto(
    val code: String,
    val secret: String? = null,
)

@Serializable
data class TotpVerifyResponseDto(
    val verified: Boolean,
    val totpEnabled: Boolean,
)

@Serializable
data class TotpSetupResponseDto(
    val secret: String,
    val qrCodeUrl: String,
)

@Serializable
data class UpdateUsernameRequestDto(
    val newUsername: String,
)

@Serializable
data class UsernameAvailableResponseDto(
    val available: Boolean,
    val reason: String? = null,
)
